import { Component, OnInit, OnDestroy } from '@angular/core';
import { SocketService } from '../services/socket.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-socket',
  standalone: true,
  imports: [],
  templateUrl: './socket.component.html',
  styleUrl: './socket.component.css'
})
export class SocketComponent {
  unreadMessageCount: number = 0;
  private subscription!: Subscription;
  private authToken: string = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJsb2dpbl91c2VyX2lkIjoiNjc1MTgzOTE5MjFkY2E2OWEyMzk4NWY0IiwibG9naW5fZW1haWwiOiJzaXZhcHJpeWFuLmFza2FuQGdtYWlsLmNvbSIsImlhdCI6MTczNTY1NDYyNCwiZXhwIjo1NDA0MzE5NTcwMjAxMTQwNTB9.37Row4ZpP5-JI6zAkVYkYFoP-1xcMocenqwbvi7ciuU";


  friendsCount: any;

  constructor(private socketService: SocketService) { }

  ngOnInit(): void {

    // this.socketService.connect(this.authToken);

    // this.subscription = this.socketService.on('unreadCount').subscribe((count: number) => {
    //   this.unreadMessageCount = count;
    // });

    // this.subscription = this.socketService.on('pendingFriendRequestCount').subscribe((count: number) => {
    //   this.friendsCount = count;
    // });
  }

}


